export default __webpack_public_path__ + "static/media/icon-settlement.f53c2847.svg";